import { Container } from "@mui/material";
import { requester } from "App";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useState } from "react";
import VendorInfoList from "../components/VendorInfoList";
import VerticalFlex from "layouts/flex/VerticalFlex";
import styles from "./VendorStoreManagement.module.css";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
function VendorStoreManagement() {
    const { userName } = useContext(AuthContext);
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState({});
    const [stores, setStores] = useState();
    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                
                setTotalAmount(result.data)
            })
            requester.findAllVendorStore((result) => {
                
                setStores(result.data);
            })

            
        }

    }, [isMounted])
    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={30}>
                    <FlexChild width={"90%"}>
                        <Center width={"100%"} textAlign={"left"}>
                            <P size={40} weight={"bold"}>전체매장관리</P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"90%"}>
                        <VerticalFlex flexStart gap={20}>
                            {
                                stores &&
                                stores.map((data, index) => {
                                    return (
                                        <VendorInfoList data={data} url={`/vendor/storeManagement/detail/${data.id}`} />

                                    );
                                })
                            }
                            {/* {
                                stores &&
                                stores.map((data, index) => {
                                    return (
                                        <VendorInfoList data={data} />

                                    );
                                })
                            }
                            {
                                stores &&
                                stores.map((data, index) => {
                                    return (
                                        <VendorInfoList data={data} />

                                    );
                                })
                            }
                            {
                                stores &&
                                stores.map((data, index) => {
                                    return (
                                        <VendorInfoList data={data} />

                                    );
                                })
                            } */}
                        </VerticalFlex>
                    </FlexChild>

                </VerticalFlex>


            </Container>
        </Container>
    );
}

export default VendorStoreManagement;